<template>
  <div class="game-tester">
    <div style="display:none">{{ updateColor() }}</div>

    <div class="tester-card-body">
      <div class="tester-header">
        <div class="tester-identity">
          <div class="tester-avatar-wrapper">
            <img id="tester-avatar" :src="this.userProfile.img">
          </div>
          <div class="tester-details">
            <div id="tester-name">{{ this.userProfile.userName }}</div>
          </div>
        </div>
        <div id="remove-tester" @click.prevent="handleRemoveTester">Remove</div>
      </div>

      <div class="tester-info-row">
        <div id="tester-achieve">Achievements: <span>{{ this.userProfile.achievementsCompleted }}</span></div>
        
        <div class="time-slot-toggle">
          <div v-show="!timeslot" @click.prevent="handleViewTimeSlot" class="toggle-link">
            <span>View Availability</span>
            <img class="arrow-icon" src="../../assets/down.png" />
          </div>
          <div v-show="timeslot" @click.prevent="handleHideTimeSlot" class="toggle-link">
            <span>Hide Availability</span>
            <img class="arrow-icon" src="../../assets/up.png" />
          </div>
        </div>
      </div>

      <div class="tester-actions-row">
          <div 
            v-if="!response" 
            class="btn-base view-response disabled-btn"
          >
            No Response
          </div>
        
          <button class="btn-base message-btn" @click="handleMessageClick">
            Message
          </button>
      </div>
    </div>

    <div v-show="timeslot" id="time-slot-list">
      <div class="slot-divider"></div>
      <div class="one-slot" v-for="(oneSlot, index) in this.userProfile.timeSlotList" :key="index">
        {{ 'From ' + oneSlot[0].replace("T", " ") + ' to ' + oneSlot[1].replace("T", " ") }}
      </div>
      <div id="edit-time-slot" @click.prevent="handleEditTimeSlot">Edit Slots</div>
    </div>
  </div>
</template>

<script>
import UserObject from "../../Firestore/UserObject";
import GameTesting from "../../Firestore/GameTesting";

export default {
  name: "gameTester",
  props: {
    id: { type: String }
  },
  data() {
    return {
      userType: window.localStorage.getItem("userType") ? parseInt(window.localStorage.getItem("userType")) : -1,
      timeslot: false,
      response: true,
      isLoading: false,
      userProfile: {
        userName: "",
        email: "",
        achievementsCompleted: "",
        img: "",
        timeSlotList: []
      },
    }
  },
  mounted() {
    this.userType = parseInt(window.localStorage.getItem("userType"));
    let that = this;
    
    UserObject.getProfile(this.id).then(res => {
      let res_data = res.data;
      that.userProfile.userName = res_data.userName;
      that.userProfile.email = res_data.email;
      that.userProfile.img = res_data.img;
      that.userProfile.achievementsCompleted = res_data.achievementsCompleted;
    }).catch(err => console.log(err));

    GameTesting.getTimeSlot(window.localStorage.getItem("gameId"), this.id).then(res => {
      this.userProfile.timeSlotList = res.data.timeSlotList;
    }).catch(err => console.log(err));
  },
  methods: {
    handleMessageClick() { this.$emit('message-tester', this.id); },
    handleGoResponse() { this.$router.push('/gamedetail/recordings'); },
    handleViewTimeSlot() { this.timeslot = true; },
    handleHideTimeSlot() { this.timeslot = false; },
    handleEditTimeSlot() { this.$emit('editTimeSlot', this.id, this.userProfile.timeSlotList); },
    handleRemoveTester() { this.$emit('removeTester', this.id); },
    updateColor() {
      // Restored this method to fix the Console Error
      var r = document.querySelector(':root');
      if (r && this.$store) {
        r.style.setProperty('--GAMETESTERB', this.$store.state.gametesterb);
        r.style.setProperty('--VIEWRES', this.$store.state.viewres);
      }
    },
  }
}
</script>

<style scoped>
.game-tester {
  width: 100%;
  padding: 16px;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-sizing: border-box;
  border-radius: 12px;
  background-color: #ffffff;
  margin-bottom: 12px;
  transition: all 0.2s ease;
}

.game-tester:hover {
  box-shadow: 0 4px 15px rgba(0,0,0,0.08);
}

.tester-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 10px;
}

.tester-identity {
  display: flex;
  gap: 12px;
  align-items: center;
}

#tester-avatar {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  object-fit: cover;
}

#tester-name {
  font-weight: bold;
  font-size: 15px;
  color: #FC7727;
}

#tester-email {
  font-size: 11px;
  color: #777;
}

#remove-tester {
  font-size: 10px;
  text-decoration: underline;
  color: #E55342;
  cursor: pointer;
}

.tester-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

#tester-achieve {
  font-size: 12px;
  color: #464444;
}
#tester-achieve span { font-weight: bold; }

.toggle-link {
  font-weight: bold;
  font-size: 10px;
  color: #999;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
}

.tester-actions-row {
  display: flex;
  gap: 8px;
}

.btn-base {
  flex: 1;
  height: 32px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
}

.message-btn { background: #5226DF; color: white; }
.view-response { background: #FC7727; color: white; }
.disabled-btn { background: #ccc; color: #666; cursor: not-allowed; }

#time-slot-list {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #eee;
}

.one-slot { font-size: 11px; color: #888; margin-bottom: 4px; }
#edit-time-slot { text-align: right; font-size: 10px; color: #E39E4D; cursor: pointer; text-decoration: underline; }

.arrow-icon { width: 8px; }
</style>


// WEBPACK FOOTER //
// src/components/game-detail/GameTester.vue